// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Retiree Contacts Page Styles */

.retiree-contacts-container {
  padding: 0;
  padding-left:  1.5rem;
  margin-left: 0;
  padding-right: 1rem;
}

.box-menu-retiree {
  padding-left: 2.3rem !important;
  margin-top: 10px;
  cursor: pointer;
}

.retiree-contacts-title {
  font-size: 26px;
  font-weight: bold;
  color: #111827;
  margin-bottom: 2rem;
  font-family: "Lato", sans-serif;
}

.retiree-contacts-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.retiree-contact-card {
  background-color: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 1.75rem;
  transition: box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
}

.retiree-contact-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.retiree-contact-card p {
  margin-bottom: 1rem;
  line-height: 1.6;
}

.retiree-contact-card p:last-child {
  margin-bottom: 0;
}

.retiree-contact-description {
  font-size: 20px;
  color: #374151;
  margin-bottom: 1rem;
  flex-grow: 1;
}

.retiree-contact-info {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin-top: 0.75rem;
}

.retiree-contact-organization {
  color: #8f003c;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}


.retiree-contact-link {
  color: #8f003c;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
  /* margin-top: 0.75rem; */
}

.retiree-contact-link:hover {
  text-decoration: underline;
  color: #8f003c;
}

/* Tablet: 2 columns */
@media (max-width: 992px) {
  .retiree-contacts-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.25rem;
  }

  .retiree-contacts-title {
    font-size: 24px;
  }
}

/* Mobile: 1 column */
@media (max-width: 768px) {
  .retiree-contacts-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .retiree-contacts-title {
    font-size: 22px;
    margin-bottom: 1.5rem;
  }

  .retiree-contact-card {
    padding: 1.5rem;
  }
}

@media (max-width: 576px) {
  .retiree-contacts-title {
    font-size: 20px;
  }

  .retiree-contact-card {
    padding: 1.25rem;
  }

  .retiree-contact-description {
    font-size: 14px;
  }

  .retiree-contact-info {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/sass/retireeContacts.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;;AAGA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Retiree Contacts Page Styles */\n\n.retiree-contacts-container {\n  padding: 0;\n  padding-left:  1.5rem;\n  margin-left: 0;\n  padding-right: 1rem;\n}\n\n.box-menu-retiree {\n  padding-left: 2.3rem !important;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.retiree-contacts-title {\n  font-size: 26px;\n  font-weight: bold;\n  color: #111827;\n  margin-bottom: 2rem;\n  font-family: \"Lato\", sans-serif;\n}\n\n.retiree-contacts-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.retiree-contact-card {\n  background-color: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  padding: 1.75rem;\n  transition: box-shadow 0.3s ease;\n  display: flex;\n  flex-direction: column;\n}\n\n.retiree-contact-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.retiree-contact-card p {\n  margin-bottom: 1rem;\n  line-height: 1.6;\n}\n\n.retiree-contact-card p:last-child {\n  margin-bottom: 0;\n}\n\n.retiree-contact-description {\n  font-size: 20px;\n  color: #374151;\n  margin-bottom: 1rem;\n  flex-grow: 1;\n}\n\n.retiree-contact-info {\n  font-size: 22px;\n  font-weight: 600;\n  color: #111827;\n  margin-top: 0.75rem;\n}\n\n.retiree-contact-organization {\n  color: #8f003c;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n\n.retiree-contact-link {\n  color: #8f003c;\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  /* margin-top: 0.75rem; */\n}\n\n.retiree-contact-link:hover {\n  text-decoration: underline;\n  color: #8f003c;\n}\n\n/* Tablet: 2 columns */\n@media (max-width: 992px) {\n  .retiree-contacts-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.25rem;\n  }\n\n  .retiree-contacts-title {\n    font-size: 24px;\n  }\n}\n\n/* Mobile: 1 column */\n@media (max-width: 768px) {\n  .retiree-contacts-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .retiree-contacts-title {\n    font-size: 22px;\n    margin-bottom: 1.5rem;\n  }\n\n  .retiree-contact-card {\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .retiree-contacts-title {\n    font-size: 20px;\n  }\n\n  .retiree-contact-card {\n    padding: 1.25rem;\n  }\n\n  .retiree-contact-description {\n    font-size: 14px;\n  }\n\n  .retiree-contact-info {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
